module.exports = __webpack_public_path__ + "img/news_edit.b9ec5773.svg";